// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"437":"60bee2ec","453":"b89d9e1f"}[chunkId] + ".chunk.js";
};